// extracted by mini-css-extract-plugin
export default {"committeePuck":"committee-puck_committeePuck__NFk61","puckTitle":"committee-puck_puckTitle__wLm84","memberPuck":"committee-puck_memberPuck__K0kht"};